var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import { Mail01 as Mail, AlertCircle } from '@untitled-ui/icons-react';
import { Decorator } from '../decorator';
export var Input = React.forwardRef(function Input(_a, ref) {
    var hint = _a.hint, label = _a.label, error = _a.error, errorMessage = _a.errorMessage, id = _a.id, fieldError = _a.fieldError, requiredIndicator = _a.requiredIndicator, className = _a.className, type = _a.type, icon = _a.icon, endIcon = _a.endIcon, rest = __rest(_a, ["hint", "label", "error", "errorMessage", "id", "fieldError", "requiredIndicator", "className", "type", "icon", "endIcon"]);
    var Icon = React.useMemo(function () {
        if (icon) {
            return icon;
        }
        switch (type) {
            case "email":
                return Mail;
            // case "tel":
            //   return Phone;
            default:
                break;
        }
    }, [type, icon]);
    var isError = !!(error || errorMessage || fieldError);
    var EndIcon = React.useMemo(function () {
        if (isError) {
            return AlertCircle;
        }
        if (endIcon) {
            return endIcon;
        }
    }, [isError, endIcon]);
    return (React.createElement(Decorator, { id: id, className: className, error: error, errorMessage: errorMessage, label: label, hint: hint, fieldError: fieldError, requiredIndicator: requiredIndicator },
        React.createElement("div", { className: "relative rounded shadow-sm" },
            Icon &&
                React.createElement("div", { className: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3" },
                    React.createElement(Icon, { className: "h-5 w-5 text-gray-500", "aria-hidden": "true" })),
            React.createElement("input", __assign({ className: classNames("block w-full rounded border-0 py-2 text-gray-900 text-base ring-1 ring-inset  placeholder:text-gray-500 focus:ring-inset focus:shadow-md disabled:bg-gray-50 disabled:text-gray-500", {
                    "pl-10": !!Icon,
                    "pl-3": !Icon,
                    "pr-10": !!EndIcon,
                    "pr-3": !EndIcon,
                    "ring-error-300 focus:shadow-error-100 focus:ring-error-300": isError,
                    "ring-gray-300 focus:shadow-primary-100 focus:ring-primary-300": !isError
                }), type: type, id: id, ref: ref }, rest)),
            EndIcon &&
                React.createElement("div", { className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3" },
                    React.createElement(EndIcon, { className: classNames("h-5 w-5", { "text-gray-500": !isError, "text-error": isError }), "aria-hidden": "true" })))));
});
